import { render, staticRenderFns } from "./QNewsSubmenu.vue?vue&type=template&id=756821c0&"
import script from "./QNewsSubmenu.vue?vue&type=script&lang=js&"
export * from "./QNewsSubmenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports